import { render } from "./promo-pop.vue?vue&type=template&id=d5039262&scoped=true&ts=true"
import script from "./promo-pop.vue?vue&type=script&lang=ts"
export * from "./promo-pop.vue?vue&type=script&lang=ts"

import "./promo-pop.vue?vue&type=style&index=0&id=d5039262&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5039262"]])

export default __exports__